// src/theme/spacing.js
// Chakra UI'nin varsayılan 4px tabanlı spacing ölçeği genellikle iyidir.
// Bu dosyayı projenizdeki mevcut spacing tanımlarıyla güncelleyebilirsiniz.
//
// Faz 4.3++ · Eksik yari/ceyrek step'ler eklendi.
// HomeHubPage gibi component'ler boxSize={5.5}, {4.5}, {9.5}, {4.75} kullaniyordu;
// bunlar Chakra'da default tanimsizdi -> CSS variable bos -> ikon intrinsic boyutuna duser.
// Tum yarim adimlar 4px tabanli scale'e uygun (X.5 = X*4 + 2px).

const space = {
  px: "1px",
  0.5: "0.125rem", // 2px
  1: "0.25rem",   // 4px
  1.5: "0.375rem", // 6px
  2: "0.5rem",    // 8px
  2.5: "0.625rem", // 10px
  3: "0.75rem",   // 12px
  3.5: "0.875rem", // 14px
  4: "1rem",      // 16px (temel birim)
  4.5: "1.125rem", // 18px · Faz 4.3++
  4.75: "1.1875rem", // 19px · Faz 4.3++
  5: "1.25rem",   // 20px
  5.5: "1.375rem", // 22px · Faz 4.3++
  6: "1.5rem",    // 24px
  6.5: "1.625rem", // 26px · Faz 4.3++
  7: "1.75rem",   // 28px
  7.5: "1.875rem", // 30px · Faz 4.3++
  8: "2rem",      // 32px
  8.5: "2.125rem", // 34px · Faz 4.3++
  9: "2.25rem",   // 36px
  9.5: "2.375rem", // 38px · Faz 4.3++
  10: "2.5rem",   // 40px
  11: "2.75rem",  // 44px · iOS HIG min tap target
  12: "3rem",     // 48px
  14: "3.5rem",   // 56px
  16: "4rem",     // 64px
  18: "4.5rem",   // 72px · Faz 4.3++
  20: "5rem",     // 80px
  22: "5.5rem",   // 88px · Faz 4.3++
  24: "6rem",     // 96px
  28: "7rem",     // 112px
  32: "8rem",     // 128px
  36: "9rem",     // 144px · Faz 4.3++
  40: "10rem",    // 160px · Faz 4.3++
  // ... ihtiyaç duyulan diğer değerler
};

export default space;
